import { render, staticRenderFns } from "./Q5.vue?vue&type=template&id=bdd435b8&"
import script from "./Q5.vue?vue&type=script&lang=ts&"
export * from "./Q5.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports